export const rolesOverTimeChartConfig = (
  title: string,
  legendData: string,
  xAxisData: string[],
  series: number[]
) => ({
  title: {
    text: title
  },
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "cross",
      label: {
        backgroundColor: "#6a7985"
      }
    }
  },
  legend: {
    data: legendData
  },
  toolbox: {
    feature: {
      saveAsImage: {}
    }
  },
  grid: {
    left: "5%",
    right: "5%"
  },
  xAxis: [
    {
      type: "category",
      boundaryGap: false,
      data: xAxisData
    }
  ],
  yAxis: [
    {
      type: "value"
    }
  ],
  dataZoom: [
    {
      type: "inside",
      start: 0,
      end: 100,
      zoomOnMouseWheel: false,
      moveOnMouseMove: false
    },
    {
      start: 0,
      end: 100
    }
  ],
  series: [
    {
      name: legendData[0],
      type: "line",
      data: series[0]
    },
    {
      name: legendData[1],
      type: "line",
      data: series[1]
    },
    {
      name: legendData[2],
      type: "line",
      data: series[2]
    }
  ]
});
